import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { FindBodyFind, OperationLog } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { GET_DATASET_DETAILS_QUERY_KEYS } from './useGetDatasetDetails';

export const useGetDatasetRowCount = ({
  name,
  find,
  lastSuccessOperation,
}: {
  name: string | undefined;
  find?: FindBodyFind;
  lastSuccessOperation?: OperationLog;
}): UseQueryResult<number | undefined> => {
  return useQuery({
    queryKey: [
      ...GET_DATASET_DETAILS_QUERY_KEYS,
      name,
      find,
      lastSuccessOperation,
    ],
    queryFn: async () => {
      if (!name)
        throw new Error(
          'Error: Dataset name is required to fetch dataset details!'
        );
      return datasetApi.dsProxyAggregateApiV1DataAggregatePost(
        {
          dataset: name,
          aggregate: [{ $match: find }, { $count: 'count' }],
        },
        undefined,
        getDatasetRequestConfig()
      );
    },
    // `$count` yields no document at all when nothing matches.
    select: res => Number(res.data.results[0]?.['count'] ?? 0),
  });
};
